/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_ApprovedInputs */



/**
* | output |
* | --- |
* | "Include Approved" |
*
* @param {Transcript_Export_Include_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_approved = /** @type {((inputs?: Transcript_Export_Include_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Approved")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Approved")
	return /** @type {LocalizedString} */ ("Include Approved")
});